import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "17 18 11 12 17 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 6v12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ChevronFirst";
const ChevronFirst = memo(themed(Icon));
export {
  ChevronFirst
};
//# sourceMappingURL=chevron-first.js.map
